import { render } from "./TableVan.vue?vue&type=template&id=c0e42fb8"
import script from "./TableVan.vue?vue&type=script&lang=js"
export * from "./TableVan.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__